import styled from 'foundations-theming/utils';
import { getImageUrl } from '../../../../utils/imageUrl';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const Background = styled.div.withConfig({
  displayName: "ProfilePageHeroBackground__Background",
  componentId: "od1kgo-0"
})(({
  blobsImageUrl,
  condensed,
  theme
}) => ({
  backgroundImage: `url(${blobsImageUrl}), linear-gradient(to right, ${theme.color['fill-accent-teal-pressed']}, ${theme.color['fill-accent-teal-default']})`,
  backgroundPosition: 'center center',
  backgroundSize: 'auto 100%',
  backgroundRepeat: 'no-repeat',
  backgroundColor: theme.color['fill-accent-teal-default'],
  maxHeight: condensed ? '189px' : 'unset'
}));
export default function ProfilePageHeroBackground({
  children,
  condensed,
  isUngatedForUnifiedAcademyNavigation
}) {
  const blobsImageUrl = getImageUrl('storefront-header-blobs.svg');
  if (isUngatedForUnifiedAcademyNavigation) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(Background, {
      blobsImageUrl: blobsImageUrl,
      condensed: condensed,
      children: children
    })
  );
}